import React from 'react';
import AsyncPage from './async';
import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';

export default [
  <ShowocaseLayout
    key="/business/showcase/nail-color"
    exact
    path="/business/showcase/nail-color"
    component={AsyncPage}
  />,
];
